import {createSelector} from 'reselect';

import {FEATURE_FLAGS} from './constants';

const gsConfigSelector = (store) => store?.gsConfig || {};
const featureFlagsSelector = createSelector(gsConfigSelector, ({features}) => features || {});
const defaultLocaleSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig?.defaultLocale);
const currentLocaleSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig?.currentLocale);
const supportedLocalesSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig?.supportedLocales || []);
const shstoreIdSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig?.shstoreId);
const defaultCurrencySelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig?.defaultCurrency);

const isAdvisoryEnabledSelector = createSelector(
  featureFlagsSelector,
  (features) => !!features[FEATURE_FLAGS.advisory.enabled]
);
const isLanguageSelectorEnabledSelector = createSelector(
  featureFlagsSelector,
  (features) => !!features[FEATURE_FLAGS.languageSelector.enabled]
);

export {
  featureFlagsSelector,
  defaultLocaleSelector,
  currentLocaleSelector,
  supportedLocalesSelector,
  shstoreIdSelector,
  defaultCurrencySelector,
  isAdvisoryEnabledSelector,
  isLanguageSelectorEnabledSelector,
};
